"use client"
import Text from "@/app/(site)/_components/Atoms/Text"
import CountryPickerSelectionItems from "@/app/(site)/_components/Organisms/Header/CountryPickerSelection/CountryPickerSelectionItems"
import { Country } from "@/app/(site)/_components/Organisms/Header/CountryPickerWrapper"
import { CountryCode } from "@/data/country-data"
import { ShippingCountryCode } from "@/data/shipping-country-code"
import {
    CentraLanguageCode,
    getLanguageLabel,
    LanguageOption
} from "@/data/supported-languages"
import { ProductMetaData } from "@/lib/content-service/types/ContentServiceProduct"
import { t } from "@/translations"
import { RequiredTokenAndSelectionMetadata } from "@/types/cookie-types"

export type ShippingDestination = {
    countryName: string | null
    countryCode: CountryCode | null
}
interface CountryPickerSelectionProps {
    langCode: "" | CentraLanguageCode
    shippingCountry: ShippingDestination | null
    countries: Country[]
    theme?: "light" | "dark"
    centraSession: RequiredTokenAndSelectionMetadata
    countriesWithLanguages: Record<ShippingCountryCode, LanguageOption[]>
    extractedAbsolutePath: string | null
    productHrefs?: ProductMetaData["hrefs"]
    isProductPage?: boolean
}

const CountryPickerSelection = ({
    countriesWithLanguages,
    langCode,
    shippingCountry,
    countries,
    centraSession,
    theme = "dark",
    extractedAbsolutePath,
    productHrefs = {},
    isProductPage = false
}: CountryPickerSelectionProps) => {
    return (
        <div className="country-picker">
            <div className="flex cursor-pointer flex-col border-t-2 border-white pb-32 pt-19 uppercase">
                <Text weight="light" size="medium">
                    {t(langCode, "header.country_selector.shipping_to")}
                </Text>
                <Text weight="light" size="medium" className="text-white/50">
                    {`${shippingCountry && shippingCountry.countryName} ${centraSession?.metadata?.currency ?? ""}`}
                </Text>
                <Text weight="light" size="medium">
                    {t(langCode, "header.country_selector.your_language")}
                </Text>
                <Text weight="light" size="medium" className="text-white/50">
                    {getLanguageLabel(
                        (
                            centraSession?.metadata?.language ?? ""
                        ).toLocaleLowerCase() as CentraLanguageCode
                    )}
                </Text>
            </div>
            <nav aria-label={t(langCode, "header.country_selector.country_selector")}>
                <ul>
                    <CountryPickerSelectionItems
                        countriesWithLanguages={countriesWithLanguages}
                        countries={countries}
                        theme={theme}
                        extractedAbsolutePath={extractedAbsolutePath}
                        productHrefs={productHrefs}
                        isProductPage={isProductPage}
                    />
                </ul>
            </nav>
        </div>
    )
}

export default CountryPickerSelection
